import React from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModal, LntModalFooter, LntSelect } from '@app/components/base'

import { CONTRACTORS_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { SIZE } from '@app/constants'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { getContractors } from '@app/api/routes/contractors'

import type { ContractorsChangeModalProps, ContractorsFormData } from './types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  size: SIZE.middle,
  strictValue: true
}

export const ContractorsChangeModal: React.FC<ContractorsChangeModalProps> = ({ onContractorsChange, ...props }) => {
  const form = useForm<ContractorsFormData>()
  const isExistValue = !!form.watch('contractorId')

  const handleSubmit = (data: ContractorsFormData): void => {
    onContractorsChange(data.contractorId)
  }

  return (
    <LntModal
      { ...props }
      title='Изменение подрядчика'
      width={ 572 }
      footer={ null }
    >
      <LntForm
        layout='vertical'
        onSubmit={ handleSubmit }
        formInstance={ form }
      >
        <LntFormItem
          defaultValue={ [] }
          label='Выберите подрядчика'
          name='contractorId'
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
            querySelect={ {
              queryKey: [CONTRACTORS_KEY.contractorsItems],
              queryFn: getContractors,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>
        <LntModalFooter>
          <LntButton
            size={ SIZE.middle }
            htmlType='submit'
            disabled={ !isExistValue }
          >
            Изменить
          </LntButton>
        </LntModalFooter>
      </LntForm>
    </LntModal>
  )
}
